import { motion } from 'framer-motion';

export default function InitialLoading() {
    return (
        <div className="fixed inset-0 z-[99999] bg-neutral-950 flex flex-col items-center justify-center overflow-hidden">
            {/* Background elements for depth */}
            <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
                <div
                    className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-orange-600/10 blur-[120px] rounded-full animate-pulse"
                    style={{ animationDuration: '4s' }}
                />
                <div
                    className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-red-600/10 blur-[120px] rounded-full animate-pulse"
                    style={{ animationDuration: '6s' }}
                />
            </div>

            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, ease: 'easeOut' }}
                className="relative flex flex-col items-center"
            >
                {/* Logo with pulse and glow */}
                <div className="relative mb-8">
                    <motion.div
                        animate={{
                            scale: [1, 1.05, 1],
                            opacity: [0.5, 0.8, 0.5]
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                        className="absolute inset-0 bg-orange-500/20 blur-2xl rounded-full"
                    />
                    <div className="relative w-32 h-32 md:w-40 md:h-40">
                        <img
                            src="/favicon.png"
                            alt="MediocreToons Logo"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>

                {/* Brand Name */}
                <h1 className="text-3xl md:text-4xl font-black mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-400 via-orange-500 to-red-600 tracking-tighter">
                    MediocreToons
                </h1>

                {/* Loading Bar */}
                <div className="w-48 h-1 bg-white/5 rounded-full overflow-hidden relative">
                    <motion.div
                        animate={{
                            x: ['-100%', '100%']
                        }}
                        transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                        className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-500 to-transparent w-full h-full"
                    />
                </div>

                <p className="mt-4 text-white/30 text-sm font-medium tracking-widest uppercase animate-pulse">
                    Carregando portal...
                </p>
            </motion.div>

            {/* Footer Text */}
            <div className="absolute bottom-10 left-0 w-full text-center">
                <p className="text-white/10 text-xs font-medium">
                    &copy; {new Date().getFullYear()} MediocreToons. All rights reserved.
                </p>
            </div>
        </div>
    );
}
